import {common} from './en/common';

const English = {
    ...common
}
export default English
